import { PHONE_DISPLAY } from "./data";

export const Footer = () => (
    <footer data-testid="site-footer" className="border-t border-[#D4AF37]/20 bg-[#FDFBF7] py-12">
        <div className="mx-auto max-w-6xl px-5">
            <p className="font-serif text-2xl font-semibold text-[#2C2A29]">
                Monisha <span className="text-[#D4AF37]">Makeover</span> Artistry
            </p>
            <p className="mt-4 max-w-3xl text-xs leading-relaxed text-[#5A5652]">
                Monisha Makeover Artistry is a trusted bridal makeup artist in Chennai, specialising in HD bridal
                makeup and Muhurtham makeup in Chennai. Based in Thiruninravur, we offer wedding makeup in Chennai
                with home service — the answer when you search for "bridal makeup near me". Call or WhatsApp{" "}
                {PHONE_DISPLAY} to reserve your date.
            </p>
            <p className="mt-6 text-xs text-[#5A5652]">
                © {new Date().getFullYear()} Monisha Makeover Artistry. All rights reserved.
            </p>
        </div>
    </footer>
);
